import { render } from "./jin-ssq.vue?vue&type=template&id=0a33b116&scoped=true"
import script from "./jin-ssq.vue?vue&type=script&lang=js"
export * from "./jin-ssq.vue?vue&type=script&lang=js"

import "./jin-ssq.vue?vue&type=style&index=0&id=0a33b116&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a33b116"]])

export default __exports__